import { Image, Link, Text, View } from "@react-pdf/renderer";
import Html from "react-pdf-html";

import attachment_img from "Assets/images/attachment_img.png"
import { extractUploadFileName } from "config/constants";
import { isHTMLContentEmpty, isValidValue } from "helpers/common";
import PDFHtmlRenderer from "../PDFHtmlRenderer";

const AnswerMultipleRecommendations = ({ recommendations, styles, fontSize = 9,}) => {
    return (
        <>
            {/* <View style={{ marginTop: 0, ...styles.flex, gap: "12px" }}>
                <View> */}
            {recommendations?.length ? (
                recommendations?.map((item, index) => {
                    const attachments = item?.attachmentData || [];
                    const answers = (isValidValue(item?.answers) && !isHTMLContentEmpty(item?.answers)) ? item?.answers : "";
                    if (!answers) {
                        return null;
                    }
                    return (
                        <>
                            <View wrap={false}>
                                {index == 0 && <View style={{ ...styles.border, marginBottom: 6 }}>
                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>RECOMMENDATIONS</Text>
                                </View>}

                                <View style={{ marginTop: 4, marginBottom: 6, paddingBottom: 8, borderBottom: "0.25px solid #333", }}>
                                    <View style={{ width: "100%", paddingRight: 7 }}>
                                        <PDFHtmlRenderer
                                            style={{ ...styles.para, fontSize }}
                                            data={answers}
                                        />
                                    </View>
                                    <View style={{ width: "100%", marginTop: 10 }}>
                                        {attachments?.length && (
                                            <View style={{ width: "100%" }}>
                                                <View>
                                                    <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                                </View>
                                                {attachments?.map((item, index) => (
                                                    <View style={{ marginTop: '7px', ...styles.flex, gap: "2px", alignItems: "flex-start", }}>
                                                        {/* <View style={{ ...styles.flex, gap: "2px", alignItems: "flex-start" }}> */}
                                                        <Text style={{ ...styles.link, borderBottom: 0 }} >
                                                            {index + 1}.
                                                        </Text>
                                                        <Link
                                                            key={index}
                                                            src={item?.attachment_name}
                                                            style={styles.link}
                                                        >
                                                            {extractUploadFileName(item?.attachment_name)}
                                                        </Link>
                                                        {/* </View> */}
                                                        {/* <Image style={{ width: 6 }} src={attachment_img} alt="attachment_img" /> */}
                                                    </View>
                                                ))}
                                            </View>
                                        )}
                                    </View>
                                </View>

                            </View>
                        </>
                    )
                })
            ) : (
                <>
                    <View style={{ ...styles.border, marginBottom: 6, width: "100%" }}>
                        <Text style={{ ...styles.mainHeading, fontSize: 10 }}>RECOMMENDATIONS</Text>
                    </View>
                    <Text style={styles.para}>No recommendations added yet</Text>
                </>
            )}

            {/* </View>
            </View> */}
        </>
    )
}

export default AnswerMultipleRecommendations;